/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-02-28 15:53:54
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-01-11 00:13:08
 * @FilePath: \baishu_react_ui\src\utils\WidgetFilter\AddressWidgetFilter.jsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import WidgetFilter from ".";

import negate from "lodash/negate";
import includes from "lodash/includes";
import concat from "lodash/concat";

import { BsyConfig } from "../../global/BsyConfig";

export default class UserWidgetFilter extends WidgetFilter {
    _init() {
        var t = this.options
            , e = BsyConfig().CONST.FILTER_METHOD;
        t.hasEmpty && t.method === e.IN && (t.value = concat(t.value, this._getNullValues()))
    }
    eq(e) {
        return function (t) {
            return t === e
        }
    }
    ne(t) {
        return negate(this.eq(t))
    }


    nin() {
        return negate(this.in.apply(null, arguments))
    }
    empty() {
        var e = this;
        return function (t) {
            return includes(e._getNullValues(), t)
        }
    }
    notEmpty() {
        return negate(this.empty())
    }


    in() {
        var e = arguments;
        return function (t) {
            return includes(e, t)
        }
    }
}
